/** init domain config */

window._CONFIG.domianURL = 'http://localhost:8080/api';
// 单点登录地址
window._CONFIG.staticDomainURL = 'http://localhost:8080/api';
window._CONFIG.pdfDomainURL = 'http://localhost:8080/api';
